import List from "@/components/list";
import router from "@/router";
import vue from "@/main";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const previewQuestion = listeners["previewQuestion"] || function () { };

  // 编辑试题
  function editQuestion({ uuid }) {
    router.push({ path: "/questionnaire/edit", query: { id: uuid } });
  }

  // 删除试题
  function deleteQuestion(question) {
    vue.$emit("deleteQuestion", question);
  }

  const Deal = ({ props: { vo } }) => {
    const paper = vo.row;
    const dealConf = [
      [
        paper.publishStatus === 0 ? "icon-edit" : "icon-edit-disable",
        "编辑",
        paper.publishStatus === 0
          ? () => {
              editQuestion(paper);
            }
          : () => {},
        "questionnaire:update"
      ],
      [
        paper.publishStatus === 0 ? "icon-delete" : "icon-delete-disable",
        "删除",
        paper.publishStatus === 0
          ? () => {
              deleteQuestion(paper);
            }
          : () => {},
        "questionnaire:delete"
      ],
      [
        "icon-preview",
        "预览",
        () => {
          previewQuestion(paper);
        },
        "questionnaire:preview"
      ]
    ];

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "问卷名称",
      prop: "questionnaireName",
      showOverflowTooltip: true,
      minWidth: '200'
    },
    {
      label: "问题总数",
      prop: "questionnaireCount",
      minWidth: '80'
    },
    {
      label: "发布状态",
      prop: "publishStatusName",
      minWidth: '80'
    },
    {
      label: "创建时间",
      prop: "createDate",
      minWidth: '120'
    },
    {
      label: "操作",
      fixed: "right",
      render: vo => <Deal vo={vo} />,
      width: '160'
    }
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
